import User from '../models/User';
import { parseMoment } from './dateConverters';
import { parseUser } from './userConverters';

export const BASE_SCHEMA = {
  id: 'id',
  createdBy: (data: any) => parseUser(data.createdBy || data.creator) || User.withId(data.createdById),
  createdOn: (data: any) => parseMoment(data.createdOn),
  updatedBy: (data: any) => parseUser(data.updatedBy || data.modifiedBy) || User.withId(data.modifiedById),
  updatedOn: (data: any) => parseMoment(data.updatedOn || data.modifiedOn),
  removedBy: (data: any) => parseUser(data.removedBy || data.deletedBy),
  removedOn: (data: any) => parseMoment(data.removedOn || data.deletedOn),
};
